(function () {
  function parseJson(node) {
    if (!node) {
      return {};
    }

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function ensureHiddenInput(form, selector, name) {
    var input = form.querySelector(selector);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    return input;
  }

  function setMessage(node, message, tone) {
    if (!node) {
      return;
    }

    node.textContent = message || '';
    if (tone) {
      node.dataset.tone = tone;
    } else {
      delete node.dataset.tone;
    }
  }

  function normalizePayload(data) {
    if (!data) {
      return null;
    }

    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        return null;
      }
    }

    if (!data || typeof data !== 'object' || data.type !== 'trade_show_signup_result') {
      return null;
    }

    return data;
  }

  function isAllowedOrigin(originValue) {
    var origin;

    try {
      origin = new URL(originValue);
    } catch (error) {
      return false;
    }

    return /^script\.google(?:usercontent)?\.com$/i.test(origin.hostname) || /\.googleusercontent\.com$/i.test(origin.hostname);
  }

  function splitContactName(value) {
    var parts = String(value || '').trim().split(/\s+/).filter(Boolean);

    if (!parts.length) {
      return {
        firstName: '',
        lastName: ''
      };
    }

    return {
      firstName: parts[0],
      lastName: parts.length > 1 ? parts.slice(1).join(' ') : ''
    };
  }

  function collectCheckedValues(inputs) {
    return inputs.reduce(function (values, input) {
      if (input.checked) {
        values.push(String(input.value || '').trim());
      }

      return values;
    }, []).filter(Boolean);
  }

  function initTradeShowSignup(section) {
    var config = parseJson(section.querySelector('[data-trade-show-signup-config]'));
    var form = section.querySelector('[data-trade-show-form]');
    var progress = section.querySelector('[data-trade-show-progress]');
    var message = section.querySelector('[data-trade-show-message]');
    var submitButton = section.querySelector('[data-trade-show-submit]');
    var success = section.querySelector('[data-trade-show-success]');
    var successHeading = section.querySelector('[data-trade-show-success-heading]');
    var successBody = section.querySelector('[data-trade-show-success-body]');
    var successModal = section.querySelector('[data-trade-show-success-modal]');
    var successModalHeading = section.querySelector('[data-trade-show-success-modal-heading]');
    var successModalBody = section.querySelector('[data-trade-show-success-modal-body]');
    var successAckButton = section.querySelector('[data-trade-show-success-ack]');
    var successCloseButtons = Array.prototype.slice.call(section.querySelectorAll('[data-trade-show-success-close]'));
    var customerTagInput = form ? form.querySelector('input[name="customer_tag"]') : null;
    var sourcePageInput = section.querySelector('[data-trade-show-source-page]');
    var iframe = section.querySelector('[data-trade-show-target]');
    var userAgentInput;
    var timezoneInput;
    var submittedAtInput;
    var firstNameInput;
    var lastNameInput;
    var sampleChoiceInput;
    var sampleVariantInput;
    var sampleHandleInput;
    var interestLevelInput;
    var contactNameInput;
    var sampleOptions;
    var interestOptions;
    var requiredFields;
    var pending = false;
    var timeoutId = 0;
    var defaultLabel;
    var normalizedCustomerTag;
    var previousFocus;

    if (!form || !submitButton || !success || !successModal || !iframe) {
      return;
    }

    userAgentInput = ensureHiddenInput(form, '[data-trade-show-user-agent]', 'user_agent');
    timezoneInput = ensureHiddenInput(form, '[data-trade-show-browser-timezone]', 'browser_timezone');
    submittedAtInput = ensureHiddenInput(form, '[data-trade-show-submitted-at]', 'submitted_at_client');
    firstNameInput = ensureHiddenInput(form, '[data-trade-show-first-name]', 'first_name');
    lastNameInput = ensureHiddenInput(form, '[data-trade-show-last-name]', 'last_name');
    sampleChoiceInput = ensureHiddenInput(form, '[data-trade-show-sample-choice]', 'sample_choice');
    sampleVariantInput = ensureHiddenInput(form, '[data-trade-show-sample-variant]', 'sample_variant_id');
    sampleHandleInput = ensureHiddenInput(form, '[data-trade-show-sample-handle]', 'sample_product_handle');
    interestLevelInput = ensureHiddenInput(form, '[data-trade-show-interest-level]', 'interest_level');
    contactNameInput = form.querySelector('[data-trade-show-contact-name]');
    sampleOptions = Array.prototype.slice.call(form.querySelectorAll('[data-trade-show-sample-option]'));
    interestOptions = Array.prototype.slice.call(form.querySelectorAll('[data-trade-show-interest-option]'));
    requiredFields = Array.prototype.slice.call(form.querySelectorAll('[required]'));
    defaultLabel = config.submitLabel || submitButton.textContent.trim();
    normalizedCustomerTag = String(config.customerTag || (customerTagInput && customerTagInput.value) || '').trim();

    if (!normalizedCustomerTag || normalizedCustomerTag === '展会Trade Show' || normalizedCustomerTag === '展会trade show') {
      normalizedCustomerTag = 'Atlanta Market 2026';
    }

    config.customerTag = normalizedCustomerTag;

    if (customerTagInput) {
      customerTagInput.value = normalizedCustomerTag;
    }

    function updateProgress() {
      var complete = 0;
      var total = requiredFields.length + (sampleOptions.length ? 1 : 0);

      requiredFields.forEach(function (field) {
        if (String(field.value || '').trim()) {
          complete += 1;
        }
      });

      if (sampleOptions.length && sampleChoiceInput.value) {
        complete += 1;
      }

      if (progress) {
        progress.style.width = (total ? Math.round((complete / total) * 100) : 0) + '%';
      }
    }

    function setSubmitting(isSubmitting) {
      submitButton.disabled = Boolean(isSubmitting);
      submitButton.textContent = isSubmitting ? (config.submittingLabel || defaultLabel) : defaultLabel;
    }

    function clearPending() {
      pending = false;
      window.clearTimeout(timeoutId);
      timeoutId = 0;
      setSubmitting(false);
    }

    function syncContactName() {
      var nameParts = splitContactName(contactNameInput ? contactNameInput.value : '');
      firstNameInput.value = nameParts.firstName;
      lastNameInput.value = nameParts.lastName;
    }

    function syncSampleChoice() {
      sampleChoiceInput.value = collectCheckedValues(sampleOptions).join(', ');
      sampleVariantInput.value = '';
      sampleHandleInput.value = '';

      if (sampleChoiceInput.value && message && message.dataset.tone === 'error') {
        setMessage(message, '');
      }
    }

    function syncInterestLevel() {
      interestLevelInput.value = collectCheckedValues(interestOptions).join(', ');
    }

    function updateSuccessCopy(payload) {
      var headingText = payload.heading || config.successHeading || (successHeading && successHeading.textContent) || '';
      var bodyText = payload.message || config.successBody || (successBody && successBody.textContent) || '';

      if (successHeading) {
        successHeading.textContent = headingText;
      }

      if (successBody) {
        successBody.textContent = bodyText;
      }

      if (successModalHeading) {
        successModalHeading.textContent = headingText;
      }

      if (successModalBody) {
        successModalBody.textContent = bodyText;
      }
    }

    function closeSuccessModal() {
      if (successModal.hidden) {
        return;
      }

      successModal.hidden = true;

      if (!document.querySelector('[data-trade-show-success-modal]:not([hidden])')) {
        document.body.classList.remove('trade-show-free-perfume-signup-modal-open');
      }

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    }

    function openSuccessModal() {
      previousFocus = document.activeElement;
      successModal.hidden = false;
      document.body.classList.add('trade-show-free-perfume-signup-modal-open');

      if (successAckButton && typeof successAckButton.focus === 'function') {
        window.setTimeout(function () {
          successAckButton.focus();
        }, 0);
      }
    }

    function showSuccess(payload) {
      updateSuccessCopy(payload);

      form.hidden = true;
      success.hidden = false;
      setMessage(message, '', 'success');
      openSuccessModal();

      if (progress) {
        progress.style.width = '100%';
      }
    }

    function handleKeydown(event) {
      if (event.key === 'Escape') {
        closeSuccessModal();
      }
    }

    function handleMessage(event) {
      var payload;

      if (!pending) {
        return;
      }

      if (!isAllowedOrigin(event.origin)) {
        return;
      }

      payload = normalizePayload(event.data);
      if (!payload) {
        return;
      }

      clearPending();

      if (payload.ok) {
        showSuccess(payload);
        return;
      }

      setMessage(message, payload.message || 'We could not submit your information. Please try again.', 'error');
    }

    function markValidationState() {
      requiredFields.forEach(function (field) {
        field.setAttribute('aria-invalid', field.validity.valid ? 'false' : 'true');
      });
    }

    window.addEventListener('message', handleMessage);
    document.addEventListener('keydown', handleKeydown);

    successCloseButtons.forEach(function (button) {
      button.addEventListener('click', closeSuccessModal);
    });

    if (sourcePageInput) {
      sourcePageInput.value = window.location.href;
    }

    userAgentInput.value = window.navigator.userAgent || '';
    timezoneInput.value = (window.Intl && Intl.DateTimeFormat().resolvedOptions().timeZone) || '';
    form.target = iframe.name;

    form.addEventListener('input', function () {
      syncContactName();
      syncSampleChoice();
      syncInterestLevel();
      updateProgress();
      markValidationState();
    });

    form.addEventListener('change', function () {
      syncContactName();
      syncSampleChoice();
      syncInterestLevel();
      updateProgress();
      markValidationState();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (pending) {
        return;
      }

      if (!config.appsScriptUrl) {
        setMessage(message, 'Apps Script Web App URL is not configured yet.', 'error');
        return;
      }

      syncContactName();
      syncSampleChoice();
      syncInterestLevel();

      if (sampleOptions.length && !sampleChoiceInput.value) {
        setMessage(message, 'Please choose at least one product before submitting.', 'error');
        updateProgress();
        return;
      }

      if (form.website && String(form.website.value || '').trim()) {
        form.reset();
        syncContactName();
        syncSampleChoice();
        syncInterestLevel();
        updateProgress();
        showSuccess({
          heading: config.successHeading,
          message: config.successBody
        });
        return;
      }

      markValidationState();
      if (!form.reportValidity()) {
        setMessage(message, 'Please complete the required fields.', 'error');
        updateProgress();
        return;
      }

      if (!firstNameInput.value) {
        setMessage(message, 'Please provide a contact name before submitting.', 'error');
        return;
      }

      form.action = config.appsScriptUrl;
      submittedAtInput.value = new Date().toISOString();
      setMessage(message, config.submittingLabel || 'Submitting...', 'info');
      setSubmitting(true);
      pending = true;

      timeoutId = window.setTimeout(function () {
        if (!pending) {
          return;
        }

        clearPending();
        setMessage(message, 'We could not confirm the submission. Please try again.', 'error');
      }, 20000);

      HTMLFormElement.prototype.submit.call(form);
    });

    syncContactName();
    syncSampleChoice();
    syncInterestLevel();
    updateProgress();
    markValidationState();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-trade-show-signup]');
    Array.prototype.forEach.call(sections, initTradeShowSignup);
  });
})();